import { ApiProperty } from "@nestjs/swagger";

export class StockTransferDto{
    @ApiProperty()
    selectedRows?:any[];
}